import '../styles/mapdebug.css'
import React from 'react';

class DebugTools extends React.Component {

    render() {

        return ( 
            <div className='debugTools'>
                <p>LON: {this.props.lon}</p>
                <p>LAT: {this.props.lat}</p>
                <p>Z: {this.props.zoom}</p>
            </div>
            );
    }
}

export default DebugTools;